import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import React, { Component } from 'react';
import isEqual from 'react-fast-compare';
import { Virtuoso } from 'react-virtuoso';
import styled from 'styled-components';

import noop from '@/utils/noop';

export interface SeeMoreItemsProps {
    className: string;
    hideSeeLess: boolean;
    itemsComponentFull: any;
    itemsComponentShort: any;
    itemsListLengthFull: number;
    itemsListLengthShort: number;
    linkClassName: string;
    onSeeLessItemsClick: Function;
    onSeeMoreItemsClick: Function;
    seeLessFormattedMessageId: string;
    seeMoreFormattedMessageId: string;
    showAllItems: boolean;
    showTotal: boolean;
}

type State = {
    seeMore: boolean;
};

export default class SeeMoreItems extends Component<SeeMoreItemsProps, State> {
    static defaultProps = {
        className: '',
        hideSeeLess: false,
        linkClassName: '',
        onSeeLessItemsClick: noop,
        onSeeMoreItemsClick: noop,
        seeLessFormattedMessageId: 'search_see_less',
        seeMoreFormattedMessageId: 'search_see_all',
        showAllItems: false,
        showTotal: false,
    };

    state = {
        seeMore: this.props.showAllItems,
    };

    shouldComponentUpdate = (nextProps: SeeMoreItemsProps, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    onSeeLess = () => {
        this.changeSeeMore();
        this.props.onSeeLessItemsClick();
    };

    onSeeMore = () => {
        this.changeSeeMore();
        this.props.onSeeMoreItemsClick();
    };

    changeSeeMore = () => {
        const seeMore = !this.state.seeMore;
        this.setState({ seeMore });
    };

    renderVirtualRow = (index: number) => {
        return this.props.itemsComponentFull[index];
    };

    render() {
        const { seeMore } = this.state;

        const {
            className,
            hideSeeLess,
            itemsComponentFull,
            itemsComponentShort,
            itemsListLengthFull,
            itemsListLengthShort,
            linkClassName,
            seeLessFormattedMessageId,
            seeMoreFormattedMessageId,
            showTotal,
        } = this.props;

        const showSeeMore = itemsListLengthFull > itemsListLengthShort && !seeMore;
        const showSeeLess = !showSeeMore && !hideSeeLess && itemsListLengthShort < itemsListLengthFull;
        const isContentList = Array.isArray(itemsComponentFull);

        let longList: any;
        if (seeMore) {
            longList = isContentList ? (
                <Virtuoso
                    initialItemCount={20}
                    itemContent={this.renderVirtualRow}
                    style={{ height: '400px' }}
                    totalCount={itemsComponentFull.length}
                />
            ) : (
                itemsComponentFull
            );
        }

        return (
            <div className={className}>
                {seeMore ? longList : itemsComponentShort}
                {showSeeMore && (
                    <StyledSeeMoreLink
                        className={linkClassName}
                        key="see-more"
                        onClick={this.onSeeMore}
                    >
                        <FormattedMessage id={seeMoreFormattedMessageId} />
                        {showTotal && <> ({itemsListLengthFull})</>}
                    </StyledSeeMoreLink>
                )}
                {showSeeLess && (
                    <StyledSeeMoreLink
                        className={linkClassName}
                        key="see-less"
                        onClick={this.onSeeLess}
                    >
                        <FormattedMessage id={seeLessFormattedMessageId} />
                    </StyledSeeMoreLink>
                )}
            </div>
        );
    }
}

const StyledSeeMoreLink = styled(ActionText)`
    && {
        display: inline-block;
        font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
        font-size: 14px;
        font-stretch: normal;
        font-style: normal;
        line-height: 21px;
        padding-left: 8px;
        width: auto;
    }
`;
